import { NlpSettings } from '@feedyou-ai/feedbot-schema'

import { GenericFormData } from '../../types'
import { FeedbotThunk } from '../../../../store/types'
import { updateBotProperties } from '../../../../actions/bot'
import { featureValueSelector } from '../../../../store/features/selectors'
import { validateAndFixDuplicateIdsInNlpSettings } from '../../../../features/flowValidation'
import { adjustModelIdsToNlpModelIdFormat } from '../../sharedSchemaFragments/nlpSettings/utils'

export const save =
  (formData: GenericFormData): FeedbotThunk =>
  async (dispatch, getState) => {
    const state = getState()
    const isUniqueIdValidationEnabled = featureValueSelector('UNIQUE_BOT_ID_VALIDATION')(state)

    const settingsWithAdjustedIds = adjustModelIdsToNlpModelIdFormat(formData as NlpSettings)
    // Validation still required for nested objects - adjustModelIdsToNlpModelIdFormat
    // only regenerates ids od models themselves, but not on entities inside models (intents, entities, options)
    const duplicateIdsValidationResult = await validateAndFixDuplicateIdsInNlpSettings(
      settingsWithAdjustedIds,
      !isUniqueIdValidationEnabled
    )

    if (duplicateIdsValidationResult.didValidateSuccessfully) {
      dispatch(updateBotProperties({ nlp: duplicateIdsValidationResult.correctedEntity }))
    }
  }
